<div class="chart-container">
  <div class="chart-title">Trend</div>
  <div #chart echarts [options]="chartOptions" [merge]="updateOptions" [initOpts]="initOptions" (chartInit)="onChartInit($event)" class="visual"></div>
</div>
